export default "__VITE_ASSET__Da1T8VzI__"